import { createSvgIcon } from '@automata/mui-theme';
export const taskDependencyIcon = createSvgIcon(
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.50001 4.8094L3.87085 6.9047V11.0953L7.50001 13.1906L8.28193 12.7392L10.2819 13.8939L7.50001 15.5L1.87085 12.25V5.75L7.50001 2.5L13.1292 5.75V9.76422L11.1292 8.60952V6.9047L7.50001 4.8094Z" />
    <path d="M13.7198 10.1052L15.7198 11.2599L16.5 10.8094L20.1292 12.9047V17.0953L16.5 19.1906L12.8708 17.0953V15.3886L10.8708 14.2339V18.25L16.5 21.5L22.1292 18.25V11.75L16.5 8.5L13.7198 10.1052Z" />
    <path d="M8.16992 8.63477L16.8302 13.6348L15.8302 15.3668L7.16992 10.3668L8.16992 8.63477Z" />
  </svg>,
  'taskDependencyIcon'
);
